document.addEventListener('DOMContentLoaded', () => {
  const $header = document.querySelector('nova-header')

  const $openMenu = $header.querySelector('.js-menu-toggle')
  const $closeMenu = $header.querySelector('.js-menu-close-button')
  const $mobileMenu = document.getElementById('mobile-menu')
  const $mobileMenuPanel = document.getElementById('mobile-menu-panel')

  document.addEventListener('nova:mobile-menu:open', () => {
    $mobileMenu.show()
    $mobileMenuPanel.setAttribute('is-open', 'true')
  })
  document.addEventListener('nova:mobile-menu:close', () => {
    $mobileMenu.hide()
    $mobileMenuPanel._handleSubMenuClose()
    $mobileMenuPanel.removeAttribute('is-open')
  })

  $mobileMenu.addEventListener('sl-hide', (e) => {
    if (e.target !== $mobileMenu) return
    $openMenu.classList.remove('hidden')
    $closeMenu.classList.add('hidden')
    $header.style.setProperty('--header-bg-color', initialBgColor)
    $mobileMenuPanel.removeAttribute('is-open')
  })

  window.addEventListener('nova:resize-width', () => {
    if ($mobileMenu.hasAttribute('open') && window.innerWidth >= 990) {
      $mobileMenu.hide()
      $mobileMenuPanel._handleSubMenuClose()
      $mobileMenuPanel.removeAttribute('is-open')
    }
  })

  const initialBgColor =
    getComputedStyle($header).getPropertyValue('--header-bg-color')

  const $drawerButtons = $header.querySelectorAll('.js-header-drawer-button')

  const $menuDrawerButtons = [...$drawerButtons].filter(
    (button) => button.dataset.type !== 'search',
  )

  const $headerDrawer = $header.querySelectorAll('.js-header-drawer')

  const $menuDrawer = [...$headerDrawer].filter(
    (drawer) => drawer.dataset.type !== 'search',
  )

  $openMenu.addEventListener('click', () => {
    $openMenu.classList.add('hidden')
    $closeMenu.classList.remove('hidden')
    $header.style.setProperty('--header-bg-color', '#fff')

    document.dispatchEvent(new CustomEvent('nova:mobile-menu:open'))
    $mobileMenuPanel.setAttribute('is-open', 'true')
  })

  $closeMenu.addEventListener('click', () => {
    handleMenuIconClose()
    document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'))
    $mobileMenuPanel.removeAttribute('is-open')
  })

  document.addEventListener('nova:menu:closed-in-modal', () =>
    handleMenuIconClose(),
  )

  const handleMenuIconClose = () => {
    $closeMenu.classList.add('hidden')
    $openMenu.classList.remove('hidden')
    $header.style.setProperty('--header-bg-color', initialBgColor)
    $mobileMenuPanel.removeAttribute('is-open')
  }

  const handleInlineMenuDrawer = (event) => {
    const $button = event.target.closest('.js-header-drawer-button')
    if (!$button) return

    const targetReference = $button.dataset.target
    const $target = $header.querySelector(`#${targetReference}`)
    if (!$target) return

    if (event.type !== 'mouseenter') {
      if ($button.hasAttribute('is-open')) {
        $target.hide()
        return
      }
    }

    for (const $drawer of $headerDrawer) {
      if ($drawer === $target) {
        if (!$drawer.hasAttribute('is-open')) {
          $drawer.show()
        }
      } else {
        $drawer.hide()
      }
    }
  }

  const closeDrawer = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')
    if (!$drawer) return
    $drawer.hide()
  }

  for (const $button of $drawerButtons) {
    $button.addEventListener('click', handleInlineMenuDrawer)
  }

  const handleDrawerAttributesAndEvents = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')
    if (!$drawer) return
    const targetReference = $drawer.id
    const $button = $header.querySelector(`[data-target="${targetReference}"]`)
    const $buttonOpenIcon = $button.querySelector('.js-header-drawer-icon-open')

    if (!$button) return
    if (event.type === 'sl-hide') {
      $drawer.removeAttribute('is-open')
      $button.removeAttribute('is-open')
      if ($buttonOpenIcon) {
        $buttonOpenIcon.classList.remove('header-search__icon--selected')
        $buttonOpenIcon.dataset.tabIndex = 0
      }
      dispatchDrawerHideEvent($drawer)

      $drawer.hide()
    } else if (event.type === 'sl-show') {
      $drawer.setAttribute('is-open', '')
      $button.setAttribute('is-open', '')
      if ($buttonOpenIcon) {
        $buttonOpenIcon.classList.add('header-search__icon--selected')
        $buttonOpenIcon.dataset.tabIndex = -1
      }
      dispatchDrawerShowEvent($drawer)
    }
  }

  const dispatchDrawerShowEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:open', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  const dispatchDrawerHideEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:close', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  for (const $drawer of $headerDrawer) {
    $drawer.addEventListener('sl-hide', handleDrawerAttributesAndEvents)
    $drawer.addEventListener('sl-show', handleDrawerAttributesAndEvents)
  }

  for (const $button of $menuDrawerButtons) {
    $button.addEventListener('mouseenter', handleInlineMenuDrawer)
  }

  for (const $drawer of $menuDrawer) {
    $drawer.addEventListener('mouseleave', closeDrawer)
  }

  document.addEventListener('click', (event) => {
    const openDrawer = [...$headerDrawer].find((drawer) =>
      drawer.hasAttribute('is-open')
    );
    if (!openDrawer) return;

    const isClickInsideDrawer = openDrawer.contains(event.target);
    const isClickOnToggleButton = [...$drawerButtons].some((button) =>
      button.contains(event.target)
    );

    if (!isClickInsideDrawer && !isClickOnToggleButton) {
      openDrawer.hide();
    }
  });

  

}, { once: true })
